import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ApiService } from '../service/api.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../loader/loader.service';
import { whitespace } from '../common/whitespace';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { APP_DATE_FORMATS } from '../service/date.adapter';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
  ],
})
export class MaintenanceComponent implements OnInit {
  maintenanceForm: any = FormGroup;
  maintenanceId: any;
  startTime: any;
  today = new Date();
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly _http: ApiService,
    private readonly toaster: ToastrService,
    private readonly LoaderService: LoaderService,
  ) { }

  ngOnInit(): void {
    this.maintenanceForm = this.formBuilder.group({
      message: ['', Validators.required, null, whitespace],
      StartDate: ['', [Validators.required, this.S_notPastDateValidator()]],
      EndDate: ['', [Validators.required, this.E_notPastDateValidator()]],
      startTime: ['', [Validators.required]],
      endTime: ['', [Validators.required]],
      isMaintenance: [false],
    });
    this.getMaintenance();
  }

  S_notPastDateValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value)
        return null;

      const inputDate = new Date(control.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      inputDate.setHours(0, 0, 0, 0);

      if (inputDate < today) {
        return { pastDate: true };
      }
      const start = this.maintenanceForm.get('StartDate')?.value;
      const end = this.maintenanceForm.get('EndDate')?.value;

      if (!start || !end)
        return null;

      const startDate = new Date(start);
      const endDate = new Date(end);

      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      if (endDate < startDate) {
        this.maintenanceForm.get('EndDate')?.setValue(start);
        return { endBeforeStart: true };
      }

      return null;
    };
  }

  E_notPastDateValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value)
        return null;

      const inputDate = new Date(control.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      inputDate.setHours(0, 0, 0, 0);

      if (inputDate < today) {
        return { pastDate: true };
      }

      const start = this.maintenanceForm.get('StartDate')?.value;
      const end = this.maintenanceForm.get('EndDate')?.value;

      if (!start || !end)
        return null;

      const startDate = new Date(start);
      const endDate = new Date(end);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      if (endDate < startDate)
        return { endBeforeStart: true };

      return null;
    };
  }

  getMaintenance() {
    this._http.getMaintenance().subscribe((res: any) => {
      if (res.Success) {
        let startTimeValue: Date = new Date();
        const startTimeString = res.Data[0].StartTime;
        const [shours, sminutes, sseconds] = startTimeString.split(':');
        startTimeValue.setHours(Number(shours));
        startTimeValue.setMinutes(Number(sminutes));
        startTimeValue.setSeconds(Number(sseconds));

        let endTimeValue: Date = new Date();
        const endTimeString = res.Data[0].EndTime;
        const [ehours, eminutes, eseconds] = endTimeString.split(':');
        endTimeValue.setHours(Number(ehours));
        endTimeValue.setMinutes(Number(eminutes));
        endTimeValue.setSeconds(Number(eseconds));

        this.maintenanceForm.controls.isMaintenance.setValue(
          res.Data[0].IsMaintenance
        );
        this.maintenanceForm.controls.StartDate.setValue(res.Data[0].StartDate);
        this.maintenanceForm.controls.EndDate.setValue(res.Data[0].EndDate);
        this.maintenanceId = res.Data[0].Id;
        this.maintenanceForm.controls.message.setValue(res.Data[0].MessageBox);
        this.maintenanceForm.controls.startTime.setValue(startTimeValue);
        this.maintenanceForm.controls.endTime.setValue(endTimeValue);
      }
    });
  }
  submit(_form: any) {
    _form.get('StartDate')?.updateValueAndValidity();
    _form.get('EndDate')?.updateValueAndValidity();

    if (_form.invalid) {
      _form.get('StartDate')?.markAsTouched();
      _form.get('EndDate')?.markAsTouched();
      _form.markAsTouched();
      return;
    }

    const startTime = _form.controls.startTime?.value;
    const endTime = _form.controls.endTime?.value;
    if (
      _form.value.endTime.setHours(new Date(endTime).getHours(), new Date(endTime).getMinutes(), 0, 0) == new Date().setHours(0, 0, 0, 0) ||
      _form.value.startTime.setHours(new Date(startTime).getHours(), new Date(startTime).getMinutes(), 0, 0) == new Date().setHours(0, 0, 0, 0)) {
      this.toaster.error('Please select Valid Time');
      return;
    }
    const starttime = _form.value.startTime;
    const endtime = _form.value.endTime;

    const start = this.maintenanceForm.get('StartDate')?.value;
    const end = this.maintenanceForm.get('EndDate')?.value;

    const startDate = new Date(start);
    const endDate = new Date(end);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if ((endDate.getDate() == startDate.getDate())) {
      if (starttime > endtime) {
        this.toaster.error('End time must be greater than start time');
        return;
      }
    }
    this.LoaderService.show();

    let obj = {
      Id: this.maintenanceId,
      StartDate: this.setNewDateValue(_form.value.StartDate),
      EndDate: this.setNewDateValue(_form.value.EndDate),
      StartTime: _form.value.startTime.toLocaleTimeString('en-US', {
        hour12: false,
      }),
      EndTime: _form.value.endTime.toLocaleTimeString('en-US', {
        hour12: false,
      }),
      MessageBox: _form.value.message,
      IsMaintenance: _form.value.isMaintenance,
    };
    this._http.updateMaintenance(obj).subscribe((res: any) => {
      if (res.Success) {
        this.LoaderService.hide();
        this.toaster.success('Maintenance updated Successfully');
        this.getMaintenance();
      } else {
        this.LoaderService.hide();
        this.toaster.error('Something went wrong');
      }
    });
  }
  setNewDateValue(date: any) {
    let tzoffset = new Date(date).getTimezoneOffset() * 60000; //offset in milliseconds
    let localISOTime;
    if (date._d) {
      localISOTime = new Date(date - tzoffset).toISOString().slice(0, -1);
      return localISOTime;
    }
    if (date.split('T')[1] != '00:00:00') {
      localISOTime = new Date(date - tzoffset).toISOString().slice(0, -1);
    } else {
      localISOTime = date;
    }
    return localISOTime;
  }
  openDialogRefforactive(event: any) {
    this.maintenanceForm.controls.isMaintenance.setValue(event.checked);
  }
}
